module.exports = __webpack_public_path__ + "34882ab8c68c3c2637d6eb77529d356a.jpg";